// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__fHHjM {

    background-color: #ffffff;
    border-radius: 0 0 6px 6px;
    padding-left: 4px;
    padding-right: 4px;
    margin-top: -32px;
    padding-bottom: 4px;
    margin-right: 2.5rem;
    margin-left: 2.5rem;

}

.styles_containerAccordion__vyEWb {
    margin-top: 2rem;
    padding: 0 2rem;
    max-height: 55vh;
    overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/ConciliacaoContabil/styles.module.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".container {\n\n    background-color: #ffffff;\n    border-radius: 0 0 6px 6px;\n    padding-left: 4px;\n    padding-right: 4px;\n    margin-top: -32px;\n    padding-bottom: 4px;\n    margin-right: 2.5rem;\n    margin-left: 2.5rem;\n\n}\n\n.containerAccordion {\n    margin-top: 2rem;\n    padding: 0 2rem;\n    max-height: 55vh;\n    overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__fHHjM`,
	"containerAccordion": `styles_containerAccordion__vyEWb`
};
export default ___CSS_LOADER_EXPORT___;
